var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCube24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9178 3.19414C12.6496 3.08685 12.3503 3.08685 12.0821 3.19414L5.37742 5.87602L12.5 8.77133L19.6225 5.87602L12.9178 3.19414ZM20.7942 6.85701L13.175 9.95421V20.203L20.1178 17.4259C20.5449 17.255 20.8249 16.8414 20.8249 16.3814V7.11867C20.8249 7.02921 20.8144 6.94151 20.7942 6.85701ZM11.825 20.203V9.95421L4.20572 6.85701C4.18552 6.94151 4.17495 7.02921 4.17495 7.11867V16.3814C4.17495 16.8414 4.45502 17.255 4.88214 17.4259L11.825 20.203ZM11.5808 1.94069C12.1708 1.70467 12.8291 1.70467 13.4191 1.94069L20.6191 4.82069C21.0284 4.98439 21.3766 5.24974 21.639 5.58051C21.9785 6.00868 22.1749 6.5475 22.1749 7.11867V16.3814C22.1749 17.3934 21.5588 18.3035 20.6191 18.6793L13.4191 21.5593C13.1241 21.6773 12.812 21.7364 12.5 21.7364C12.1879 21.7364 11.8758 21.6773 11.5808 21.5593L4.38076 18.6793C3.4411 18.3035 2.82495 17.3934 2.82495 16.3814V7.11867C2.82495 6.5475 3.02137 6.00868 3.36095 5.58051C3.62329 5.24974 3.97151 4.98439 4.38076 4.82069L11.5808 1.94069Z",
    fill: "white",
    fillOpacity: 0.96
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCube24);
export default __webpack_public_path__ + "static/media/Cube-24.91ce0dcbf6ff1d6c2ed2145500843982.svg";
export { ForwardRef as ReactComponent };